"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Send = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: 17,
  height: 16,
  viewBox: "0 0 17 16",
  fill: "none"
}, props), _react.default.createElement("path", {
  className: "fill",
  d: "M1.478 0a.5.5 0 0 0-.465.628L2.68 6.873l7.357 1.126L2.68 9.124 1.013 15.37a.5.5 0 0 0 .708.577l15-7.5a.5.5 0 0 0 0-.894l-15-7.5A.5.5 0 0 0 1.478 0z"
}));

var _default = Send;
exports.default = _default;